import { LightboxDispatcher } from "../Variables";

import { ActionType } from "../ActionType";

export class LightboxActionsCreator {
    public static update(lightboxes: string[]): void {
        LightboxDispatcher.dispatch({ actionType: ActionType.Update, payload: lightboxes });
    }
}
